import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
    .use(initReactI18next) // Bind React
    .use(LanguageDetector) // Detect user language
    .init({
        resources: {
            en: {
                translation: {
                    "links.dataprivacy": "https://biathlonhub.com/privacy-policy",

                    "menu.home": "Home",
                    "menu.athletes": "Athletes",
                    "menu.events": "Events",
                    "menu.shootingRange": "Shooting range",
                    "menu.settings": "Settings",

                    "home.intro.hi": "Hi",
                    "home.intro.youAreNotLoggedIn": "I see you are not logged in. Do you want to log in or register?",
                    "home.intro.itsNotNecessaryToRegister": "It's not neccessary to register, but it allows you to have the changes up-to-date on multiple devices. And as extra, the premium users can share the data with other people.",

                    "settings.headline": "Settings",
                    "settings.user": "User",
                    "settings.user.logout": "Logout",
                    "settings.user.currentlyNoUser": "You are not logged in",
                    "settings.user.register": "Sign up",
                    "settings.user.login": "Sign in",
                    "settings.general": "General",
                    "settings.general.language": "Language",
                    "settings.info": "Information",
                    "settings.info.version": "Version",
                    "settings.info.author": "Author",

                    "athletes.headline": "Athletes",
                    "athletes.save": "Save",
                    "athletes.searchFor": "Search for..",
                    "athletes.noAthleteFoundForFilter": "No athlete found for this filter",
                    "athletes.removeConfirmation": "Are you sure you want to delete this athlete?",
                    "athletesDetail.backToDetail": "Back to athlete detail",
                    "athletes.addNew": "Add new",
                    "athletes.noAthleteFound": "No athlete was found.",
                    "athletesNew.headline": "New Athlete",
                    "athletesNew.backToList": "Back to athlete list",
                    "athletes.nickname": "Nick name",
                    "athletes.firstname": "First name",
                    "athletes.lastname": "Last name",
                    "athletes.email": "Email",
                    "athletes.gender": "Gender",
                    "athletes.height": "Height",
                    "athletes.weight": "Weight",
                    "athletes.bmi": "BMI",
                    "athlete.bib": "Bib",
                    "athlete.eventNote": "Notes for this event",

                    "athletesDetail.backToList": "Back to athlete list",
                    "athletesDetail.edit": "Edit athlete",
                    "athletesDetail.remove": "Remove athlete",
                    "athletesDetail.notFound": "Athlete not found!",
                    "athletesDetail.removed": "Athlete was removed",
                    "athleteDetail.Health": "Health",
                    "athleteDetail.personalInfo": "Personal information",
                    "athletesDetail.goShooting": "go shooting",

                    "athletesGroups.headline": "Groups",
                    "athletesGroups.addNew": "Add a new group",
                    "athletesGroupsNew.headline": "New group",
                    "athletesGroupsNew.backToList": "Back to group list",

                    "athletesEquiptment.headline": "Equiptment",
                    "athletesEquiptment.addNew": "Add a new equiptment",
                    "athletesEquiptmentNew.headline": "New Equiptment",
                    "athletesEquiptmentNew.backToList": "Back to equiptment list",

                    "athletesShooting.addNew": "Start a new shooting",

                    "events.headline": "Events",
                    "events.addNew": "Add a new event",
                    "events.backToList": "Back to event list",
                    "eventsDetail.backToDetail": "Back to event",
                    "events.newEvent": "New event",
                    "eventDetail.edit": "Edit event",
                    "eventDetail.generalInfo": "General info",
                    "eventDetail.shootings": "Shootings",
                    "event.title": "Title",
                    "event.date": "Date",
                    "event.type": "Event type",
                    "event.type.training": "Training",
                    "event.type.race": "Race",
                    "event.type.none": "---",
                    "event.save": "Save",
                    "events.noEventsFound": "No events found.",
                    "eventDetail.backToList": "Back to event list",
                    "eventDetail.notFound": "Event was not found",
                    "eventDetail.athletes": "Attached athletes",
                    "eventDetail.athletes.addNew": "Add new",
                    "eventDetail.athletes.noLinked": "No attached athletes yet",
                    "event.athlete.viewProfile": "visit profile",
                    "event.athlete.edit": "edit athlete info",
                    "event.athlete.goShooting": "go shooting",
                    "event.athletes.noFoundAthlete": "No athlete found. Try to create a new one.",
                    "event.athletes.createNew": "Create a new athlete",
                    "eventDetail.athlete.remove": "Unattach athlete from event",
                    "eventDetail.remove": "Remove event",
                    "event.removeConfirmation": "Are you sure you want to remove this event?",

                    "shootingDetail.headline": "Shooting",
                    "shootingDetail.backToList": "Back to all shootings",
                    "athletesShooting.noShootings": "No shooting yet",
                    "shootingDetail.notFound": "Shooting was not found",
                    "shootingDetail.removeConfirmation": "Are you sure you want to remove this shooting?",
                    "shootingDetail.removed": "The shooting was removed",
                    "shootingDetail.notePlaceholder": "Note for this shooting...",
                    "shooting.noEvent": "[Ad hoc]",
                    "shooting.addAthleteToEventConfirmation": "Current athlete is not attched to this event. Do you want to attach him?",
                    "shooting.addAthleteToEventConfirmation/f": "Current athlete is not attched to this event. Do you want to attach her?",
                    "shooting.addAthleteToEventConfirmation/m": "Current athlete is not attched to this event. Do you want to attach him?",
                    "eventDetail.athlete.removeConfirmation": "Do you really want to remove this athlete including his shots from this event? The shots will remain assigned to the athlete, but will not be included in this event.",




                    "shootingrange.headline": "Shooting range",
                    "shooting.p": "P",
                    "shooting.s": "S",
                    "shooting.guest": "Guest",
                    "shooting.race": "Race",
                    "shooting.training": "Training",
                    "shooting.zeroing": "Zeroing",
                    "shooting.relatedMissing": "Shootings are not available.",

                    "user.login.headline": "Sign in",
                    "user.login.email": "Email",
                    "user.login.password": "Password",
                    "user.login.login": "Sign in",
                    "user.login.youAreAlreadyLoggedIn": "You are already logged in.",
                    "user.login.dontHaveAnAcc": "Don't have an account?",
                    "user.login.register": "Register",
                    "user.login.loginFailed": "Login failed",
                    "user.login.loginFailedUnexpectedError": "Unexpected error during login.",
                    "user.regirstation.headline": "Registration",
                    "user.regirstation.email": "Email",
                    "user.regirstation.password": "Password",
                    "user.regirstation.submit": "Registrate",
                    "user.registration.haveAnAcc": "Already have an account?",
                    "user.registration.login": "Login",
                    "user.registration.fillAllFields": "Please fill out all fields.",
                    "user.registration.anErrorAppeared": "An error occurred. Please try again later.",
                    "user.registration.IAgreeWith": "I agree with",
                    "user.registration.dataprivacy": "Privacy Policy",
                    "user.registration.mustAgreeToRules": "You have to agree with rules.",
                },
            },
            cz: {
                translation: {
                    "links.dataprivacy": "https://biathlonhub.com/privacy-policy",

                    "menu.home": "Domů",
                    "menu.athletes": "Sportovci",
                    "menu.events": "Události",
                    "menu.shootingRange": "Střelnice",
                    "menu.settings": "Nastavení",

                    "home.intro.hi": "Ahoj",
                    "home.intro.youAreNotLoggedIn": "Vidím, že nejsi přihlášený. Chceš se přihlásit nebo registrovat?",
                    "home.intro.itsNotNecessaryToRegister": "Není nutné se registrovat, ale přihlášení ti přinese řadu výhod, jako je přenos data mezi dalšími tvými zařízeními. Navíc, jako prémiový uživatel můžeš sdílet data i s dalšími lidmi.",

                    "settings.headline": "Nastavení",
                    "settings.user": "Uživatel",
                    "settings.user.logout": "Odhlásit",
                    "settings.user.currentlyNoUser": "Není přihlášený žádný uživatel",
                    "settings.user.register": "Registrovat se",
                    "settings.user.login": "Přihlásit se",
                    "settings.general": "Obecné",
                    "settings.general.language": "Jazyk",
                    "settings.info": "Informace",
                    "settings.info.version": "Verze",
                    "settings.info.author": "Autor",

                    "athletes.headline": "Sportovci",
                    "athletes.save": "Uložit",
                    "athletes.searchFor": "Hledat..",
                    "athletes.noAthleteFoundForFilter": "Pro tento filter jsme nenašli žádného sportovce",
                    "athletes.removeConfirmation": "Skutečně chcete odstranit tohoto sportovce?",
                    "athletes.addNew": "Přidat nového",
                    "athletes.noAthleteFound": "Nebyl nalezen žádný sportovec.",
                    "athletesNew.headline": "Nový sportovec",
                    "athletesNew.backToList": "Zpět na seznam sportovců",
                    "athletes.nickname": "Přezdívka",
                    "athletes.firstname": "Jméno",
                    "athletes.lastname": "Příjmení",
                    "athletes.email": "Email",
                    "athletes.gender": "Pohlaví",
                    "athletes.height": "Výška",
                    "athletes.weight": "Hmotnost",
                    "athletes.bmi": "BMI",
                    "athletesDetail.goShooting": "jít na střelbu",
                    "athleteDetail.Health": "Zdraví",
                    "athleteDetail.personalInfo": "Osobní informace",
                    "athlete.bib": "Startovní číslo",
                    "athlete.eventNote": "Poznámky pro tuto událost",

                    "athletesDetail.backToList": "Zpět na seznam sportovců",
                    "athletesDetail.backToDetail": "Zpět na sportovce",
                    "athletesDetail.edit": "Upravit sportovce",
                    "athletesDetail.remove": "Odstranit sportovce",
                    "athletesDetail.notFound": "Sportovec nebyl nalezen!",
                    "athletesDetail.removed": "Sportovec byl odstraněn",

                    "athletesGroups.headline": "Skupiny",
                    "athletesGroups.addNew": "Přidat novou skupinu",
                    "athletesGroupsNew.headline": "Nová skupina",
                    "athletesGroupsNew.backToList": "Zpět na seznam skupin",

                    "athletesEquiptment.headline": "Vybavení",
                    "athletesEquiptment.addNew": "Přidat nové vybavení",
                    "athletesEquiptmentNew.headline": "Nové vybavení",
                    "athletesEquiptmentNew.backToList": "Zpět na seznam vybavení",

                    "athletesShooting.addNew": "Začít novou střelbu",

                    "events.headline": "Události",
                    "events.addNew": "Přidat novou událost",
                    "eventDetail.edit": "Upravit událost",
                    "events.backToList": "Zpět na seznam událostí",
                    "eventsDetail.backToDetail": "Zpět na událost",
                    "eventDetail.generalInfo": "Obecné informace",
                    "events.newEvent": "Nová událost",
                    "event.title": "Název",
                    "event.date": "Datum události",
                    "event.type": "Typ události",
                    "event.type.training": "Trénink",
                    "event.type.race": "Závod",
                    "event.type.none": "---",
                    "event.save": "Uložit",
                    "eventDetail.backToList": "Zpět na seznam událostí",
                    "eventDetail.notFound": "Událost nebyla nalezena",
                    "events.noEventsFound": "Nebyly nalezeny žádné události.",
                    "eventDetail.athletes": "Přiřazení sportovci",
                    "eventDetail.athletes.addNew": "přidat sportovce",
                    "event.athlete.viewProfile": "navštívit profil",
                    "event.athlete.edit": "upravit informace",
                    "event.athlete.goShooting": "jít střílet",
                    "eventDetail.shootings": "Střelby",
                    "event.athletes.noFoundAthlete": "Nebyl nalezen žádný další sportovec, zkuste vytvořit nového",
                    "event.athletes.createNew": "Vytvořit nového sportovce",
                    "eventDetail.athletes.noLinked": "Zatím nejsou přiřazeni žádní sportovci",
                    "eventDetail.remove": "Odstranit událost",
                    "event.removeConfirmation": "Skutečně chcete odstranit tuto událost?",

                    "shootingDetail.headline": "Střelba",
                    "shootingDetail.backToList": "Zpět na všechny střelby",
                    "athletesShooting.noShootings": "Zatím tu není žádná střelba",
                    "shootingDetail.notFound": "Střelba nebyla nalezena",
                    "shootingDetail.removeConfirmation": "Skutečně chcete odstranit tuto střelbu?",
                    "shootingDetail.removed": "Střelba byla odstraněna",
                    "shootingDetail.notePlaceholder": "Poznámka k této střelbě..",
                    "shooting.noEvent": "[Ad hoc]",
                    "shooting.addAthleteToEventConfirmation": "Akutální sportovec není přiřazen k události. Chcete ho k události přířadit?",
                    "shooting.addAthleteToEventConfirmation/f": "Akutální sportovkyně není přiřazena k události. Chcete ji k události přířadit?",
                    "shooting.addAthleteToEventConfirmation/m": "Akutální sportovec není přiřazen k události. Chcete ho k události přířadit?",
                    "eventDetail.athlete.remove": "Odebrat sportovce z událsoti",
                    "eventDetail.athlete.removeConfirmation": "Chcete skutečně odebrat tohoto sportovce včetně jeho střeleb z této události? Střelby zůstanou přiřazeny ke sportovci, ale nebudou zařazeny do této události.",

                    "shootingrange.headline": "Střelnice",
                    "shooting.p": "L",
                    "shooting.s": "S",
                    "shooting.guest": "Host",
                    "shooting.race": "Závod",
                    "shooting.training": "Trénink",
                    "shooting.zeroing": "Nástřel",
                    "shooting.relatedMissing": "Střelby nejsou dostupné",

                    "user.login.headline": "Přihlášení",
                    "user.login.email": "Email",
                    "user.login.password": "Heslo",
                    "user.login.login": "Přihlásit se",
                    "user.login.youAreAlreadyLoggedIn": "Nyní jsi už přihlášený.",
                    "user.login.dontHaveAnAcc": "Ještě nemáš účet?",
                    "user.login.register": "Registrace",
                    "user.login.loginFailed": "Přihlašování selhalo",
                    "user.login.loginFailedUnexpectedError": "Neočekávaná chyba během přihlašování",
                    "user.regirstation.headline": "Registrace",
                    "user.regirstation.email": "Email",
                    "user.regirstation.password": "Heslo",
                    "user.regirstation.submit": "Registrovat",
                    "user.registration.haveAnAcc": "Už máš účet?",
                    "user.registration.login": "Přihlásit se",
                    "user.registration.fillAllFields": "Prosíme, vyplňte všechna pole.",
                    "user.registration.anErrorAppeared": "Objevila se chyba. Zkus zopakovat akci později.",
                    "user.registration.IAgreeWith": "Souhlasím s",
                    "user.registration.dataprivacy": "pravidly",
                    "user.registration.mustAgreeToRules": "Musíte souhlasit s pravidly.",
                },
            },
        },
        fallbackLng: "en", // Default language
        debug: false,
        interpolation: { escapeValue: false }, // React already escapes content
    });

export default i18n;
